<!--
@Description: 分享品牌榜单
@Author: 吳廣帥
@Date:2021/10/20 - 16:05
@Name:brand
@Version:v1.0
-->
<style scoped lang="less">
/** 最外层div盒子*/
.brand-box {
  box-sizing: border-box;
  padding: 0;
  margin: 0;
  width: 100%;
  height: 100%;
  background: #03031C;
  #live-brand{
    width: 100%;
    background: #03031C;
    //头部
    .header {
      position: relative;
      .header-img{
        width:100%;
      }
      .date-box{
        top: 2.82rem;
        padding: 0 0.34rem;
        z-index: 1;
        position: absolute;
        .title{
          font-size: 0.28rem;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #FFFFFF;
          line-height: 0.28rem;
          margin-bottom: 0.22rem;
        }
        .date{
          font-size: 0.28rem;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #FFFFFF;
          line-height: 0.4rem;
          padding: 0.04rem 0.2rem;
          background: #6A172C;
          border-radius: 0.23rem;
        }
      }
      .category-img{
        position: absolute;
        width:100%;
        z-index: 2;
        top:4.32rem;
        left: 0;
        padding: 0 0.34rem;
      }
      .category-label-box{
        width: 100%;
        padding: 0 0.34rem;
        height: 0.98rem;
        position: absolute;
        top:4.32rem;
        left: 0;
        z-index: 3;
        display: flex;
        flex-direction: row;
        align-items: center;
        .category-label{
          font-size: 0.36rem;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #FFFFFF;
          line-height: 0.36rem;
          width: 3.2rem;
          text-align: center;
          transform: translateY(-0.1rem);
        }
        .category-default-label{
          font-size: 0.28rem;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #F7E9D8;
          line-height: 0.28rem;
          flex: 1;
          text-align: center;
        }
      }
    }

    .table{
      background: #03031C;
      padding: 0 0.34rem;
      width: 100%;
      margin-top: 0.54rem;
      position: relative;
      z-index: 3;
      height: 15rem;
      .header{
        border-radius: 0.16rem 0.16rem 0rem 0rem;
        width: 100%;
        height: 0.92rem;
        background: #F5F5F5;
        padding: 0 0.24rem;
        line-height: 0.92rem;
        font-size: 0.28rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333330;
      }
      .content{
        width: 100%;
        background: #ffffff;
        .row{
          padding:0.24rem;
          width: 100%;
          position: relative;
          display: flex;
          align-items: center;
          &:nth-of-type(1){
            background: linear-gradient(270deg, rgba(255, 255, 255, 0) 0%, #F8EEDB 100%);
          }
          &:nth-of-type(2){
            background: linear-gradient(270deg, rgba(255, 255, 255, 0) 0%, #D9E4F9 100%);
          }
          &:nth-of-type(3){
            background: linear-gradient(270deg, rgba(255, 255, 255, 0) 0%, #F4D7D7 100%);
          }
          .index{
            width: 0.18rem;
            height: 0.32rem;
            font-size: 0.28rem;
            font-family: Roboto-Bold, Roboto;
            font-weight: bold;
            color: #797C85;
            line-height: 0.32rem;
          }
          .logo{
            width: 0.84rem;
            height: 0.84rem;
            border-radius: 0.16rem;
            border: 0.02rem solid #E6E6E8;
            margin-left: 0.2rem;
            text-align: center;
            line-height: 0.84rem;
            font-size: 0.36rem;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #2A89F4;
            background: #E3F1FF;
            object-fit: contain;
          }
          .name{
            font-size: 0.28rem;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #333333;
            line-height: 0.28rem;
            margin-left: 0.18rem;
            width:2.8rem;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
          }
          .sales{
            flex: 1;
            text-align: right;
            font-size: 0.32rem;
            font-family: Roboto-Bold, Roboto;
            font-weight: bold;
            color: #FF5000;
            line-height: 0.32rem;
          }
          .icon{
            position: absolute;
            left: 0;
            top: 0;
            width: 0.57rem;
            height: 0.48rem;
          }
        }
        .tip{
          font-size: 0.24rem;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #999999;
          line-height: 0.24rem;
          text-align: center;
          padding: 0.48rem 0 ;
        }
      }


    }
    .bottom{
      margin-top: 0.3rem;
      background: #03031C;
      width: 100%;
      padding: 0  0.34rem 0.34rem 0.34rem;
      border-radius: 0rem 0rem 0.16rem 0.16rem;
      height: 4.46rem;
      line-height: 0.26rem;
      .box{
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        width: 100%;
        height: 100%;
        background: #F5F5F5;
        border-radius: 0rem 0rem 0.16rem 0.16rem;
        font-size: 0.26rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
        .qr-code{
          width: 2.12rem;
          height: 2.12rem;
          border: 0.01rem solid #E6E6E8;
          padding: 0.16rem;
          .img{
            width: 100%;
            height: 100%;
          }
        }
        .tip{
          margin-top: 0.48rem;
        }
        .url{
          margin-top: 0.02rem;
          letter-spacing: 4px;
        }
      }
    }

  }
}
</style>

<template>
  <!--  组件最外层盒子-->
  <div class="brand-box">
    <img v-if="Dynamic.shareImgSrc" style="width: 100%;z-index: 999" :src="Dynamic.shareImgSrc" alt="share">
    <div id="live-brand" v-else>
      <header class="header">
        <img src="https://s6.bihukankan.com/img/1634717962beijing@2x.png" alt="背景" class="header-img">
        <div class="date-box">
          <div class="title">{{Dynamic.dateLabel}}</div>
          <div class="date">{{Dynamic.dateTime}}</div>
        </div>
        <img src="https://s6.bihukankan.com/img/1634721106fangkuai_214124@2x.png" alt="背景" class="category-img">
        <div class="category-label-box">
          <div class="category-label">{{Dynamic.category}}</div>
          <div class="category-default-label">销售榜Top10</div>
        </div>
      </header>
      <main class="table">
        <div class="header">
          <span>排名</span>
          <span style="margin-left: 0.88rem">品牌</span>
          <span style="float: right">销售额</span>
        </div>
        <div class="content">
          <div class="row"  v-for="(item , index) of tableData" :key="index">
            <div class="index" v-if="index > 2">{{index + 1}}</div>
            <div class="index" v-else><img :src="Static.sortConfig[index]" alt="排名" class="icon"></div>
            <img :src="item.logo" alt="logo" class="logo" v-if="item.logo">
            <div class="logo" v-else>{{ item.name.slice(0,1) }}</div>
            <div class="name">{{item.name}}</div>
            <div class="sales">{{item.sales}}</div>
          </div>
          <div class="tip">
            本榜单来源于公开数据，不代表快手平台官方观点
          </div>
        </div>
      </main>
      <div class="bottom">
        <div class="box">
          <div class="qr-code">
            <img src="https://s6.bihukankan.com/img/1634730401二维码图片_10月20日19时46分20秒.png" alt="qrcode" class="img">
          </div>
          <div class="tip">长按二维码，了解更多数据</div>
          <div class="url">bihukankan.com</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import html2canvas from "html2canvas";
import moment from "moment";

export default {

  /** 方法区 **/
  methods: {
    /** 获取数据接口 **/
    async getListData() {
      const res = await this.$get({
        road: 'brandStatistic',
        params: this.Params,
        version: 'v22'
      })
      this.Dynamic.listData = res?.data?.data || []
      this.drawImg()
    },
    /** 创建分享图 **/
    drawImg() {
      const loading = this.$message.loading('正在生成分享图', 0);
      setTimeout(() => {
        html2canvas(document.getElementById('live-brand'), {
          useCORS: true,
          allowTaint: false,
          logging: false,
          letterRendering: true
        }).then(canvas => {
          this.Dynamic.shareImgSrc = canvas.toDataURL('image/png');
          this.$message.success('生成分享图成功！长按即可保存图片');
        }).catch(err => {
          this.$message.info('生成分享图失败，可尝试使用手机自带截屏功能');
        }).finally(() => {
          loading();
        });
      }, 1000)
    },
    /** 解析地址参数 **/
    parseQuery(){
      const query = this.$route.query
      this.Dynamic.category = query?.firstCategory || '类目总榜'
      this.Dynamic.dateLabel = this.Static.dateConfig[query.timeMode].name || '-'
      if (this.Static.dateConfig[query.timeMode].during) {
        this.Dynamic.dateTime =
            moment(query.time).subtract(6,'days').format(this.Static.dateConfig[query.timeMode].format)
            + '至' +
            moment(query.time).format(this.Static.dateConfig[query.timeMode].format)
      }
      else{
        this.Dynamic.dateTime = moment(query.time).format(this.Static.dateConfig[query.timeMode].format)
      }
      this.Params = { ...this.$route.query,isShare:true }
    },
  },
  async mounted() {
    await this.parseQuery()
    await this.getListData()
  },
  computed: {
    tableData() {
      return this.Dynamic.listData.map((ele, index) => {
        return {
          sort: index > 2 ? 3 : index,
          name: ele?.brand?.name || '-',
          sales: '¥' + this.$retainWan(ele.sales) || '-',
          logo: ele?.brand?.image || '',
        }

      })
    }
  },
  data() {
    return {
      /** 静态数据（存放静态地址、组件内静态json数据等） **/
      Static: {
        sortConfig: ['https://s6.bihukankan.com/img/1634724008111111@2x.png','https://s6.bihukankan.com/img/1634724193222222@2x.png','https://s6.bihukankan.com/img/16347242003333@2x.png'],
        dateConfig: {
          12:{
            name:'月榜',
            during:false,
            format:'yyyy-MM'
          },
          13:{
            name:'周榜',
            during:true,
            format:'yyyy-MM-DD'
          },
          14:{
            name:'日榜',
            during:false,
            format:'yyyy-MM-DD'
          }
        }
      },
      Params:{},
      /** 动态数据 （存放组件的动态改变信息）**/
      Dynamic: {
        shareImgSrc: '', // 图片内存地址
        category:'', // 类目名称
        dateLabel:'', // 时间单位
        dateTime:'2021-10-01至2021-12-01', // 实际时间
        listData: []
      }
    }
  }
}
</script>








